import { Controller } from "@hotwired/stimulus"
import { createHereMap, disposeHereMap, circleIcon } from "../helpers/here_map_helpers"

const SEVERITY_COLORS = {
  critical: "#ef4444",
  delayed: "#fb923c",
  at_risk: "#facc15",
}

export default class extends Controller {
  static targets = ["map"]
  static values = { markers: Array }

  connect() {
    createHereMap(this.mapTarget, { center: this.computeCenter(), zoom: 6 })
      .then(({ H, map }) => this.addMarkers(H, map))
      .catch((error) => console.error("HERE map failed to load", error))
  }

  disconnect() {
    disposeHereMap(this.map)
    this.map = null
  }

  addMarkers(H, map) {
    this.map = map
    this.markersValue.forEach((marker) => {
      const color = SEVERITY_COLORS[marker.severity] || SEVERITY_COLORS.at_risk
      map.addObject(
        new H.map.Marker(
          { lat: parseFloat(marker.lat), lng: parseFloat(marker.lng) },
          { icon: circleIcon(color) },
        ),
      )
    })
  }

  computeCenter() {
    if (!this.markersValue.length) return { lat: 51.1657, lng: 10.4515 }

    const lats = this.markersValue.map((m) => parseFloat(m.lat))
    const lngs = this.markersValue.map((m) => parseFloat(m.lng))
    return {
      lat: (Math.min(...lats) + Math.max(...lats)) / 2,
      lng: (Math.min(...lngs) + Math.max(...lngs)) / 2,
    }
  }
}
